import VIPRedemptionStatus from "enums/vip-redemption-status";

export const redeemPointsFilterState = () => ({
  startDate: null,
  endDate: null,
  statuses: [VIPRedemptionStatus.Pending, VIPRedemptionStatus.Success, VIPRedemptionStatus.Failed],
  searchKey: "",
  searchType: "vipRedemptionId",
  page: 1,
  perPage: 10,
});
